import * as React from "react";
import { SVGProps } from "react";
const SvgEditNoLine = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m18.951 7.198 2.598 1.5-1 1.731-2.598-1.5 1-1.731ZM13.05 23.42l-2.598-1.5 6.5-11.258 2.598 1.5-6.5 11.258Zm-4.3 4.446a1 1 0 0 0 .97.017l4.164-2.214c.166-.088.303-.221.397-.383l9.5-16.454a1.002 1.002 0 0 0-.366-1.366l-4.33-2.5a.998.998 0 0 0-1.366.366l-9.5 16.454c-.094.162-.14.348-.134.535l.165 4.714c.012.302.157.58.394.76l.106.071Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgEditNoLine;
